import * as actionTypes from '../actions/actionTypes';

const initialState = {
    error: null,
    loading: false,
    data: []
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_SITES_START:
            return {
                ...state,
                error: null,
                loading: true,
                data: []
            };
        case actionTypes.GET_SITES_SUCCESS:
            return {
                ...state,
                error: null,
                loading: false,
                data: action.sites
            };
        case actionTypes.GET_SITES_FAIL:
            return {
                ...state,
                error: action.error,
                loading: false
            };
        case actionTypes.SET_FAVORITE_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case actionTypes.SET_FAVORITE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                data: action.sites
            };
        case actionTypes.SET_FAVORITE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state;
    }
};

export default reducer;